module.exports = __webpack_public_path__ + "static/img/6.7e9e1b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/6.png
// module id = hGWH
// module chunks = 4